import { Sentry } from '@shared/app/scripts/services/sentry';

/**
 * @ngdoc directive
 * @name v6CoreModule.directive:swCheckVersion
 * @description
 * swCheckVersion is an attribute directive. It compares version in index.html
 * (provided via attribute) with the version in service. In case of versions
 * being different, there is an error logged in sentia
 *
 * ## Usage example
 * <pre>
 *   <div sw-check-version="v6.1.9">
 *   </div>
 * </pre>
 */
angular
  .module('v6CoreModule')
  .directive('swCheckVersion', (sentry: Sentry, version) => ({
    restrict: 'A',

    link: function (scope, elm, attrs) {
      if (attrs.swCheckVersion !== version) {
        sentry.captureException(
          // @ts-ignore
          'index.html (' +
            attrs.swCheckVersion +
            ') & js (' +
            version +
            ') version mismatch',
        );
      }
    },
  }));
